import React, { useEffect, useContext } from 'react'
import { string } from 'prop-types'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { Input } from '@mc/design-system'

import useClipboard from '../hooks/useClipboard'
import { trackShareExternallyClicked } from '../events'
import { SHARE_OPTIONS } from '../constants'
import ShareContext from '../provider/ShareContext'
import i18nInstance from '../i18n/i18nInstance'

const CopyLinkInput = ({ link, id }: { link: string; id: string | number }) => {
  const { t } = useTranslation('@mc/share')
  const shareData = useContext(ShareContext)
  const { copied, onCopy } = useClipboard()

  useEffect(() => {
    if (shareData === null) {
      return
    }

    if (copied) {
      trackShareExternallyClicked({
        channel: SHARE_OPTIONS.COPY,
        link,
        shareData,
      })
    }
  }, [copied, link, shareData])

  const CopyLink = (
    <button
      className='mc-text-h7 mc-text--capitalize mc-clickable mc-text-color--dark'
      onClick={() => onCopy(link)}
      data-testid='copy-button'
    >
      {copied ? t('copied') : t('copy')}
    </button>
  )

  return (
    <div className='d-flex'>
      <Input
        className='mc-form-element--disabled'
        value={link}
        readOnly
        append={CopyLink}
        data-testid='copy-input'
        id={id}
      />
    </div>
  )
}

CopyLinkInput.propTypes = {
  link: string.isRequired,
  id: string.isRequired,
}

export default withI18nContext(i18nInstance)(CopyLinkInput)
